import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'MuiIProgressStepper' })(
  ({ type, brandColors, typography }) => ({
    progressBar: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: typography.pxToRem(20),
    },
    stepText: {
      ...type['16_medium'],
      color: brandColors.primaryMain,
    },
    step: {
      display: 'flex',
    },
    connectorLine: {
      borderLeft: `1px solid ${brandColors.primaryMain}`,
      height: typography.pxToRem(40),
    },
  })
);

export default useStyles;
